module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-contact-tag"
  }, [_c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "lxm-contact-tag__tag"
  }, [_c('lxm-tag', {
    attrs: {
      "color": '#ff6743',
      "text": '2016年'
    }
  })], 1), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return [_c('lxm-contact-item', {
      attrs: {
        "avatar": item.avatar,
        "name": item.name,
        "phone": item.phone,
        "id": item.id,
        "isFemale": item.isFemale
      }
    })]
  }), _vm._v(" "), (_vm.hasMore) ? _c('lxm-more', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.moreClicked
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7c340d57", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c340d57!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Contact/Tag.vue
// module id = 874
// module chunks = 0